import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BackupPanel = () => {
  const [activeSubTab, setActiveSubTab] = useState('backup');

  const subTabs = [
    { id: 'backup', label: 'Create Backup', icon: 'Database' },
    { id: 'restore', label: 'Restore', icon: 'RefreshCw' },
    { id: 'schedule', label: 'Schedule', icon: 'Calendar' }
  ];

  const mockBackups = [
    { id: 1, name: 'Full Backup - Jan 15', date: '2024-01-15', size: '2.4 GB', type: 'full' },
    { id: 2, name: 'Database Backup - Jan 14', date: '2024-01-14', size: '890 MB', type: 'database' },
    { id: 3, name: 'Files Backup - Jan 13', date: '2024-01-13', size: '1.2 GB', type: 'files' }
  ];

  const renderSubTabContent = () => {
    switch (activeSubTab) {
      case 'backup':
        return (
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-soft p-6">
              <h3 className="font-heading font-semibold text-lg text-text-primary mb-4">
                Create New Backup
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div className="border border-border rounded-lg p-4 hover:border-primary-200 transition-colors cursor-pointer">
                  <div className="flex items-center mb-3">
                    <div className="w-8 h-8 bg-primary-100 rounded-lg flex items-center justify-center mr-3">
                      <Icon name="Database" size={16} className="text-primary" />
                    </div>
                    <h4 className="font-medium text-text-primary">Full Backup</h4>
                  </div>
                  <p className="text-text-secondary text-sm">
                    Complete backup including database and files
                  </p>
                </div>
                <div className="border border-border rounded-lg p-4 hover:border-primary-200 transition-colors cursor-pointer">
                  <div className="flex items-center mb-3">
                    <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                      <Icon name="Database" size={16} className="text-blue-600" />
                    </div>
                    <h4 className="font-medium text-text-primary">Database Only</h4>
                  </div>
                  <p className="text-text-secondary text-sm">
                    Backup database content only
                  </p>
                </div>
                <div className="border border-border rounded-lg p-4 hover:border-primary-200 transition-colors cursor-pointer">
                  <div className="flex items-center mb-3">
                    <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-3">
                      <Icon name="Folder" size={16} className="text-green-600" />
                    </div>
                    <h4 className="font-medium text-text-primary">Files Only</h4>
                  </div>
                  <p className="text-text-secondary text-sm">
                    Backup uploaded files and assets
                  </p>
                </div>
              </div>
              <div className="flex justify-center">
                <Button variant="primary" disabled>
                  Create Backup
                </Button>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-soft p-6">
              <h3 className="font-heading font-semibold text-lg text-text-primary mb-4">
                Recent Backups
              </h3>
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-surface-100">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Backup Name
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Date
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Size
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Type
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-border">
                    {mockBackups.map((backup) => (
                      <tr key={backup.id} className="hover:bg-surface-50">
                        <td className="px-4 py-3">
                          <div className="flex items-center">
                            <div className="w-8 h-8 bg-primary-100 rounded-lg flex items-center justify-center mr-3">
                              <Icon name="Archive" size={16} className="text-primary" />
                            </div>
                            <span className="font-medium text-text-primary">{backup.name}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-text-secondary">{backup.date}</td>
                        <td className="px-4 py-3 text-text-secondary">{backup.size}</td>
                        <td className="px-4 py-3">
                          <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                            backup.type === 'full' ? 'bg-primary-100 text-primary' : 
                            backup.type === 'database'? 'bg-blue-100 text-blue-600' : 'bg-green-100 text-green-600'
                          }`}>
                            {backup.type}
                          </span>
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex items-center space-x-2">
                            <button className="text-primary hover:text-primary-600">
                              <Icon name="Download" size={16} />
                            </button>
                            <button className="text-red-500 hover:text-red-700">
                              <Icon name="Trash2" size={16} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
      case 'restore':
        return (
          <div className="bg-white rounded-xl shadow-soft p-6">
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="RefreshCw" size={32} className="text-primary" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
                Restore from Backup
              </h3>
              <p className="text-text-secondary mb-6">
                Restore your platform from a previous backup
              </p>
              <Button variant="outline" disabled>
                Select Backup to Restore
              </Button>
            </div>
          </div>
        );
      case 'schedule':
        return (
          <div className="bg-white rounded-xl shadow-soft p-6">
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Calendar" size={32} className="text-primary" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
                Backup Schedule
              </h3>
              <p className="text-text-secondary mb-6">
                Configure automatic backup schedules
              </p>
              <Button variant="outline" disabled>
                Setup Schedule
              </Button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-primary to-secondary rounded-xl p-6 text-white">
        <h2 className="font-heading font-bold text-2xl mb-2">
          Backup & Restore
        </h2>
        <p className="text-white/90">
          Manage platform backups and restore points
        </p>
      </div>

      {/* Sub Navigation */}
      <div className="bg-white rounded-xl shadow-soft p-6">
        <div className="flex flex-wrap gap-2">
          {subTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveSubTab(tab.id)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                activeSubTab === tab.id
                  ? 'bg-primary text-white' :'text-text-secondary hover:bg-surface-100'
              }`}
            >
              <Icon name={tab.icon} size={16} />
              <span className="font-medium">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Sub Tab Content */}
      {renderSubTabContent()}
    </div>
  );
};

export default BackupPanel;